const works = {
    state: {
        form: {},
        images: [],
        video: {},
        categorys: [],
        materials: [],
        ajaxData: {}
    },
    mutations: {
        GET_WORKS_DATA: (state, value) => {
            let data = JSON.parse(tools.cache.get('worksData'));
            if (data) {
                data.form.years = new Date(data.form.years);
                state.form = data.form;
                state.images = data.images ? data.images : [];
                state.video = data.video;
                state.categorys = data.categorys ? data.categorys : [];
                state.materials = data.materials ? data.materials : [];
                state.ajaxData = data.ajaxData;
            }
        },
    },
    actions: {
        getWorksData({ commit }, value) {
            commit('GET_WORKS_DATA', value)
        }
    }
}

export default works


// WEBPACK FOOTER //
// ./src/store/modules/works.js